export const HIRING_TYPE_TCB = {
  DIRECT: 1,
  INSTITUTION: 2,
  FAMILY_BOOKLET: 3,
};
